<script>
export default {
  components: {},
};
</script>

<template>
    <div class="container"> 
          <div class="my-5 pt-5">
              <slot />
        </div>
    </div>
</template>
